import React, { useContext } from 'react';
import { get, isArray, isString, parseDate } from '@libs/shared';
import { PLUGIN_ARGUMENT_FIELD_TYPE, PLUGIN_ARGUMENT_VALUE_FROM } from '../../../interfaces';
import CustomDatetime from '../../../components/custom-date-time';
import { PluginComponentContext } from '../plugin-component';
import FieldVariableSelect from '../field-variable-select';
import { ConfigProviderContext } from '@fx-ui/fine-design';

/**
 * 插件-日期时间
 */
const PluginDatetime = () => {
    const { timezone } = useContext(ConfigProviderContext);

    const pluginComponentStore = useContext(PluginComponentContext);

    if (!pluginComponentStore) {
        return null;
    }

    const { field, fieldValue, isView, checkStatusVisible, onChange } = pluginComponentStore;

    const renderContext = () => {
        const selectType = get(fieldValue, 'resolver_type', PLUGIN_ARGUMENT_VALUE_FROM.LITERAL);
        const { isRequired, isEnabled } = field;
        const value = fieldValue.resolver_arg;

        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.LITERAL) {
            const dateFormat = 'yyyy-MM-dd HH:mm:ss';
            return (
                <CustomDatetime
                    format={dateFormat}
                    isView={isView}
                    disabled={!isEnabled}
                    status={checkStatusVisible && isRequired && !value ? 'error' : undefined}
                    value={isString(value) ? parseDate(value, timezone)! : undefined}
                    onChange={(v) => {
                        onChange(v && v.toISOString());
                    }}
                />
            );
        }
        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.PROCESS_VAR) {
            return (
                <FieldVariableSelect
                    value={isArray(value) ? value : undefined}
                    argumentType={PLUGIN_ARGUMENT_FIELD_TYPE.DATETIME}
                />
            );
        }
    };

    return <div className="fx-plugin-datetime">{renderContext()}</div>;
};

export default PluginDatetime;
